import { render, staticRenderFns } from "./nestedList.vue?vue&type=template&id=aff25cc6&"
import script from "./nestedList.vue?vue&type=script&lang=js&"
export * from "./nestedList.vue?vue&type=script&lang=js&"
import style0 from "./nestedList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports